
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators';

import CommonModule from '@/store/modules/common'

const Props = Vue.extend({
  props: {
  }
})

@Component({
  name: 'SettingsDialog',
})
export default class DefinitionActions extends Props {
  close() {
    const module = getModule(CommonModule, this.$store);
    module.setSettingsDialogVisibility(false)
  }

  get settingsDialogVisible(): boolean {
    const module = getModule(CommonModule, this.$store);
    return module.settingsDialogVisible
  }

  set settingsDialogVisible(visible: boolean) {
    const module = getModule(CommonModule, this.$store);
    module.setSettingsDialogVisibility(visible)
  }

  get themeOptions(): string[] {
    const module = getModule(CommonModule, this.$store);
    return module.themeOptions
  }

  get theme(): string {
    const module = getModule(CommonModule, this.$store);
    return module.settings.theme
  }

  set theme(theme: string) {
    const module = getModule(CommonModule, this.$store);
    module.setTheme(theme)
  }
}
